import { signIn } from "supertokens-web-js/recipe/emailpassword";

export interface OrganizationData {
  orgId: string;
  email: string;
  password: string;
  name: string;
  orgName: string;
  orgDescription: string;
}

export class AccountOnboardingService {
  private static readonly API_URL = process.env.REACT_APP_API_URL;

  static async createStripeAccount(): Promise<string> {
    const response = await fetch(`${this.API_URL}/stripe-connect/account`, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error('Failed to create account');
    }

    const data = await response.json();
    return data.account;
  }

  static async createAccountSession(accountId: string): Promise<any> {
    const response = await fetch(`${this.API_URL}/stripe-connect/account_session`, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        account: accountId
      })
    });

    if (!response.ok) {
      throw new Error('Failed to create account session');
    }

    return response.json();
  }

  // static async deleteStripeAccount(accountId: string): Promise<void> {
  //   if (!accountId) {
  //     return;
  //   }

  //   try {
  //     await fetch(`${this.API_URL}/stripe-connect/account/${accountId}`, {
  //       method: 'DELETE',
  //       credentials: 'include',
  //       headers: {
  //         'Content-Type': 'application/json'
  //       }
  //     });
  //   } catch (error) {
  //     console.error('Error deleting account:', error);
  //     throw error;
  //   }
  // }

  static async createOrganization(orgData: OrganizationData, stripeAccountId: string): Promise<void> {
    const response = await fetch(`${this.API_URL}/tenants`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        tenantId: orgData.orgId,
        email: orgData.email,
        password: orgData.password,
        name: orgData.name,
        orgName: orgData.orgName,
        orgDescription: orgData.orgDescription,
        stripeAccountId
      })
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || 'Failed to create tenant and user');
    }

    // Store the tenant ID in localStorage
    localStorage.setItem('tenantId', orgData.orgId.toLowerCase());

    // Sign in the user after successful signup
    const signInResponse = await signIn({
      formFields: [{
        id: "email",
        value: orgData.email
      }, {
        id: "password",
        value: orgData.password
      }]
    });

    if (signInResponse.status !== "OK") {
      throw new Error('Failed to sign in after signup');
    }
  }
} 